'use strict';

var _classCallCheck = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/inherits");

var _slicedToArray = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('./error'),
    TimeoutError = _require.TimeoutError,
    AbortError = _require.AbortError;

var _require2 = require('../fetch'),
    Response = _require2.Response,
    Request = _require2.Request,
    Headers = _require2.Headers,
    fetch = _require2.default;
/**
 * @typedef {import('../types').FetchOptions} FetchOptions
 * @typedef {import('../types').ProgressFn} ProgressFn
 */

/**
 * Fetch with progress
 *
 * @param {string | Request} url
 * @param {FetchOptions} [options]
 * @returns {Promise<ResponseWithURL>}
 */


var fetchWithProgress = function fetchWithProgress(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var request = new XMLHttpRequest();
  request.open(options.method || 'GET', url.toString(), true);
  var timeout = options.timeout,
      headers = options.headers;

  if (timeout && timeout > 0 && timeout < Infinity) {
    request.timeout = timeout;
  }

  if (options.overrideMimeType != null) {
    request.overrideMimeType(options.overrideMimeType);
  }

  if (headers) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = new Headers(headers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref3 = _step.value;

        var _ref2 = _slicedToArray(_ref3, 2);

        var name = _ref2[0];
        var value = _ref2[1];
        request.setRequestHeader(name, value);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  if (options.signal) {
    options.signal.onabort = function () {
      return request.abort();
    };
  }

  if (options.onUploadProgress) {
    request.upload.onprogress = options.onUploadProgress;
  } // Note: Need to use `arraybuffer` here instead of `blob` because `Blob`
  // instances coming from JSDOM are not compatible with `Response` from
  // node-fetch (which is the setup we get when testing with jest because
  // it uses JSDOM which does not provide a global fetch
  // https://github.com/jsdom/jsdom/issues/1724)


  request.responseType = 'arraybuffer';
  return new Promise(function (resolve, reject) {
    /**
     * @param {Event} event
     */
    var handleEvent = function handleEvent(event) {
      switch (event.type) {
        case 'error':
          {
            resolve(Response.error());
            break;
          }

        case 'load':
          {
            resolve(new ResponseWithURL(request.responseURL, request.response, {
              status: request.status,
              statusText: request.statusText,
              headers: parseHeaders(request.getAllResponseHeaders())
            }));
            break;
          }

        case 'timeout':
          {
            reject(new TimeoutError());
            break;
          }

        case 'abort':
          {
            reject(new AbortError());
            break;
          }

        default:
          {
            break;
          }
      }
    };

    request.onerror = handleEvent;
    request.onload = handleEvent;
    request.ontimeout = handleEvent;
    request.onabort = handleEvent; // @ts-expect-error options.body can be a node readable stream, which isn't compatible with XHR, but this
    // file is a browser override so you won't get a node readable stream so ignore the error

    request.send(options.body);
  });
};

var fetchWithStreaming = fetch;
/**
 * @param {string | Request} url
 * @param {FetchOptions} options
 */

var fetchWith = function fetchWith(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return options.onUploadProgress != null ? fetchWithProgress(url, options) : fetchWithStreaming(url, options);
};
/**
 * Parse Headers from a XMLHttpRequest
 *
 * @param {string} input
 * @returns {Headers}
 */


var parseHeaders = function parseHeaders(input) {
  var headers = new Headers();
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = input.trim().split(/[\r\n]+/)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var line = _step2.value;
      var index = line.indexOf(': ');

      if (index > 0) {
        headers.set(line.slice(0, index), line.slice(index + 1));
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return headers;
};

var ResponseWithURL =
/*#__PURE__*/
function (_Response) {
  _inherits(ResponseWithURL, _Response);

  /**
   * @param {string} url
   * @param {BodyInit} body
   * @param {ResponseInit} options
   */
  function ResponseWithURL(url, body, options) {
    var _this;

    _classCallCheck(this, ResponseWithURL);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponseWithURL).call(this, body, options));
    Object.defineProperty(_assertThisInitialized(_this), 'url', {
      value: url
    });
    return _this;
  }

  return ResponseWithURL;
}(Response);

module.exports = {
  fetch: fetchWith,
  Request: Request,
  Headers: Headers
};